/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'

// material UI
// import Grid from '@material-ui/core/Grid'
// import Typography from '@material-ui/core/Typography'
// import Paper from '@material-ui/core/Paper'
// import Box from '@material-ui/core/Box'
// import Button from '@material-ui/core/Button'
// import TextField from '@material-ui/core/TextField'

// material ui icon
// import GetAppIcon from '@material-ui/icons/GetApp'

// my components
// import withCompWidth from 'commonHoc/withCompWidth'
// import UserComponentName from 'components/molecules/UserComponentName'

// my containers
// import UserContainerName from 'containers/UserContainerName'
// import CommonButton from 'containers/CommonButtonContainer'

// libraries
// import config from 'config'
import { isFunction } from 'lib/detectType'
// import isEqualProps from 'lib/isEqualProps'

const styles = theme => ({
  root: {
    borderRadius: 5,
    paddingTop: 2,
    paddingBottom: 2,
    border: '1px solid #ccc',
    background: '#fff',
    cursor: 'pointer',
    '&:hover': {
      border: `1px solid #aaa`
    }
  },
  disabledRoot: {
    color: 'rgba(16, 16, 16, 0.3)',
    border: '1px solid #ccc !important'
  }
})
export const useProps = {}
/**
 * (작성된 설명이 없습니다.)
 */
const MiniButton = React.memo(({ classes, proxy, ...props }) => {
  const {
    className,
    style = {},
    children,
    onClick,
    onClickDisabled,
    disabled = false,
    ...others
  } = props
  return (
    <button
      {...others}
      disabled={isFunction(onClickDisabled) ? false : disabled}
      className={classNames(classes.root, className, {
        [classes.disabledRoot]: disabled === true
      })}
      onClick={
        disabled === true && isFunction(onClickDisabled)
          ? onClickDisabled
          : onClick
      }
      style={Object.assign(
        {
          cursor:
            !disabled || (disabled === true && isFunction(onClickDisabled))
              ? 'pointer'
              : 'default'
        },
        style
      )}
    >
      {children}
    </button>
  )
})

MiniButton.defaultProps = setDefaultProps(useProps)
MiniButton.propTypes = setPropTypes(useProps)
export default withStyles(styles)(MiniButton)
